import type { IUserInfo } from "@/hooks/use-user-info";
import type Widget from "@/model/widget";
import httpClient from "@/services/index";

export type WidgetListResponse = Record<string, Widget[]>;

const widgetList = (userInfo: IUserInfo): Promise<WidgetListResponse> => {
  const data = {
    loginGroupId: userInfo.loginGroupId,
    memberId: userInfo.memberId,
    groupId: userInfo.groupId,
    divisionId: userInfo.divisionId,
    username: userInfo.username,
    planId: userInfo.planId,
  };
  const config = {
    url: "/home/widgetList",
    method: "POST",
    data,
    headers: {
      Authorization: `Bearer ${userInfo.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "8.0",
      sid: "01646e27de0a4e94b2901a0bac4c649a",
    },
  };
  return httpClient.request(config).then((res) => {
    if (res.data.data) {
      return res.data.data as WidgetListResponse;
    } else {
      if (res.data.message) {
        console.error(res.data.message);
        throw new Error(res.data.message);
      } else {
        throw new Error("No data");
      }
    }
  });
};
export default widgetList;
